import * as React from "react";
import { css } from "@emotion/core";
import { SinkOrder } from "../../interfaces";
import { buildOrderRows } from "../../utils/orderTypeLabel";

interface OrdersTableProps {
  orders: SinkOrder[];
}

const COLUMNS = [
  { key: "id", header: "ID", nowrap: true, dim: true },
  { key: "typeLabel", header: "Type", nowrap: false, dim: false },
  { key: "createdBy", header: "Created By", nowrap: true, dim: false },
  { key: "submitted", header: "Submitted", nowrap: true, dim: false },
  { key: "completed", header: "Completed", nowrap: true, dim: false },
] as const;

const headerCss = css`
  font-size: 0.625rem;
  font-weight: 500;
  color: var(--neutral-4);
  text-transform: uppercase;
`;

const cellCss = (dim: boolean, nowrap: boolean) => css`
  color: ${dim ? "var(--neutral-4)" : "var(--neutral-3)"};
  font-size: 0.875rem;
  ${nowrap ? "white-space: nowrap;" : ""}
`;

const OrdersTable: React.FC<OrdersTableProps> = ({ orders }) => {
  const rows = React.useMemo(() => buildOrderRows(orders), [orders]);

  if (orders.length === 0) return null;

  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: auto auto auto auto auto;
        column-gap: 2rem;
        row-gap: 0.5rem;
        width: fit-content;
      `}
    >
      {COLUMNS.map((col) => (
        <span key={col.key} css={headerCss}>
          {col.header}
        </span>
      ))}
      {rows.map((row) => (
        <React.Fragment key={row.id}>
          {COLUMNS.map((col) => (
            <span key={col.key} css={cellCss(col.dim, col.nowrap)}>
              {row[col.key]}
            </span>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

export default OrdersTable;
